function AdminStudentsController($scope, $state) {}
AdminStudentsController.$inject = ["$scope", "$state"];
export default AdminStudentsController;
